import {
  DmConversationMessagesQuerySchema as DmConversationMessagesQuerySchemaInternal,
  DmConversationMessagesResponseSchema as DmConversationMessagesResponseSchemaInternal,
  DmConversationSummarySchema as DmConversationSummarySchemaInternal,
  DmConversationsQuerySchema as DmConversationsQuerySchemaInternal,
  DmConversationsResponseSchema as DmConversationsResponseSchemaInternal,
  DmMessageAttachmentSchema as DmMessageAttachmentSchemaInternal,
  DmMessageReactionSchema as DmMessageReactionSchemaInternal,
  DmMessageSummarySchema as DmMessageSummarySchemaInternal,
  DmMessageUrlEntitySchema as DmMessageUrlEntitySchemaInternal,
  DmParticipantSummarySchema as DmParticipantSummarySchemaInternal,
} from '@sweetistics/contracts';
import type { z } from 'zod';

export const DmConversationMessagesQuerySchema = DmConversationMessagesQuerySchemaInternal;
export const DmConversationMessagesResponseSchema = DmConversationMessagesResponseSchemaInternal;
export const DmConversationSummarySchema = DmConversationSummarySchemaInternal;
export const DmConversationsQuerySchema = DmConversationsQuerySchemaInternal;
export const DmConversationsResponseSchema = DmConversationsResponseSchemaInternal;
export const DmMessageAttachmentSchema = DmMessageAttachmentSchemaInternal;
export const DmMessageReactionSchema = DmMessageReactionSchemaInternal;
export const DmMessageSummarySchema = DmMessageSummarySchemaInternal;
export const DmMessageUrlEntitySchema = DmMessageUrlEntitySchemaInternal;
export const DmParticipantSummarySchema = DmParticipantSummarySchemaInternal;

export type DmConversationMessagesQuery = z.infer<typeof DmConversationMessagesQuerySchema>;
export type DmConversationMessagesResponse = z.infer<typeof DmConversationMessagesResponseSchema>;
export type DmConversationSummary = z.infer<typeof DmConversationSummarySchema>;
export type DmConversationsQuery = z.infer<typeof DmConversationsQuerySchema>;
export type DmConversationsResponse = z.infer<typeof DmConversationsResponseSchema>;
export type DmMessageAttachment = z.infer<typeof DmMessageAttachmentSchema>;
export type DmMessageReaction = z.infer<typeof DmMessageReactionSchema>;
export type DmMessageSummary = z.infer<typeof DmMessageSummarySchema>;
export type DmMessageUrlEntity = z.infer<typeof DmMessageUrlEntitySchema>;
export type DmParticipantSummary = z.infer<typeof DmParticipantSummarySchema>;
